import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Table, TableHead, TableBody } from "component/common/Table";
import TableFilter from "component/common/TableFilter";
import Pagination from "component/common/Pagination";
import AddButton from "component/common/AddButton/index";
import { getStatusColor, dateDifference, getRoleAction } from "utils/helper";
import { getAllDonation, deleteDonation } from "service/Donation";
import Moment from "react-moment";
import DeleteConfirmation from "component/common/DeleteConfirmation";
import Loader from "component/common/Loader";
import queryString from "query-string";
import eye from "assets/images/eye.svg";
import edit from "assets/images/edit.svg";
import dustbin from "assets/images/dustbin.svg";

import styles from "./DonationList.module.scss";
import { Toast } from "utils/toast";

const DonationList = () => {
  let location = useLocation();

  let history = useHistory();

  const { isOperationAvailable } = getRoleAction("Donation");

  const head = [
    "Item Code",
    "Product Name",
    "Category",
    "Original Price",
    "Seller Name",
    "Seller Rating (5)",
    "Status",
    "Stock Duration",
    "",
  ];

  const page = new URLSearchParams(location.search).get("page");

  const product = new URLSearchParams(location.search).get("product");

  const sort = new URLSearchParams(location.search).get("sort");

  const status = new URLSearchParams(location.search).get("status");

  const category = new URLSearchParams(location.search).get("category");

  // const rating = new URLSearchParams(location.search).get("rating");

  const code = new URLSearchParams(location.search).get("code");

  const seller = new URLSearchParams(location.search).get("seller");

  let [donation, setDonation] = useState();

  let [confirmation, setConfirmation] = useState(false);

  let [id, setId] = useState(null);

  let [totalPages, setTotalPages] = useState();

  useEffect(() => {
    getDonation();
  }, [location.search]);

  const getDonation = async () => {
    let params = {
      page: page != null ? page : 1,
      code: code,
      productStatus: status,
      categoryName: category,
      sellerName: seller,
      sortPrice: sort,
      productTitle: product,
      // sellerRating: rating,
    };
    try {
      let response = await getAllDonation(params);
      if (response.status == 200) {
        setDonation(response.data.data.data);
        setTotalPages(response.data.data.pageMeta.totalPages);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const handlePageChange = async (event) => {
    let params = queryString.stringify({
      code: code ? code : undefined,
      status: status ? status : undefined,
      category: category ? category : undefined,
      seller: seller ? seller : undefined,
      sort: sort ? sort : undefined,
      product: product ? product : undefined,
    });
    if (params == "") {
      history.push(`/admin/donation/list?page=${event}`);
    } else {
      history.push(`/admin/donation/list?${params}&page=${event}`);
    }
    // setDonation(null);
  };

  const onDelete = async () => {
    try {
      let response = await deleteDonation(id);
      if (response.status == 200) {
        getDonation();
        toggleConfirmation();
        Toast({
          type: "success",
          message: "Product has been deleted successfully",
        });
        setId(null);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const toggleConfirmation = () => {
    setConfirmation(!confirmation);
  };

  const showConfirmation = (id) => {
    setId(id);
    toggleConfirmation();
  };

  if (donation == null) return <Loader />;

  return (
    <>
      <div className="row mb-2">
        <div className="col-md-6">
          <div className={styles.donation_title}>
            <b>Donations</b>
          </div>
        </div>
        {isOperationAvailable("Add Donation") && (
          <div className="col-md-6 d-flex justify-content-end mt-2">
            <Link to="/admin/donation/select-category">
              <AddButton label="ADD DONATION" />
            </Link>
          </div>
        )}
      </div>
      <Table>
        <TableHead className={styles.donation_head} head={head} />
        <TableBody>
          <TableFilter page="donation" />
          {donation.length > 0 ? (
            donation.map((list, index) => {
              return (
                <tr
                  key={index}
                  className={styles.donation_body}
                  style={{ verticalAlign: "center" }}
                >
                  <td>{list.itemNo}</td>
                  <td>{list.productTitle}</td>
                  <td>{list.categoryInfo[0]?.categoryName}</td>
                  <td>
                    {Number(list.salePrice).toLocaleString("en-IN", {
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "INR",
                    })}
                  </td>
                  <td>{list.sellerinfo?.[0]?.sellerName}</td>
                  <td>{list.rating}</td>
                  <td>
                    <span className={getStatusColor(list.productStatus, false)}>
                      {list.productStatus}
                    </span>
                  </td>
                  <td
                    style={{
                      color: dateDifference(list.productCreatedAt)
                        ? "#CC0000"
                        : "#222529",
                    }}
                  >
                    <Moment fromNow>{list.productCreatedAt}</Moment>
                  </td>
                  <td>
                    <UncontrolledDropdown>
                      <DropdownToggle tag="span" data-toggle="dropdown">
                        <i className="icon-dots"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        {isOperationAvailable("View") && (
                          <Link to={`/admin/donation/detail/${list._id}`}>
                            <DropdownItem>
                              <div className="dropdown-items">
                                <img src={eye} />
                                <span>View</span>
                              </div>
                            </DropdownItem>
                          </Link>
                        )}
                        {isOperationAvailable("Edit") && (
                          <Link to={`/admin/donation/edit/${list._id}`}>
                            <DropdownItem>
                              <div className="dropdown-items">
                                <img src={edit} />
                                <span>Edit</span>
                              </div>
                            </DropdownItem>
                          </Link>
                        )}
                        {isOperationAvailable("Delete") && (
                          <DropdownItem
                            onClick={() => showConfirmation(list._id)}
                          >
                            <div className="dropdown-items">
                              <img src={dustbin} />
                              <span>Delete</span>
                            </div>
                          </DropdownItem>
                        )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="9" className="no-record">
                No Records Found
              </td>
            </tr>
          )}
        </TableBody>
      </Table>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          activePage={page != null ? page : 1}
          onPageChange={handlePageChange}
        />
      )}
      <DeleteConfirmation
        message="Are you sure to delete this product?"
        isOpen={confirmation}
        toggle={toggleConfirmation}
        onSubmit={onDelete}
      />
    </>
  );
};

export default DonationList;
